import { Component } from '@angular/core';

@Component({
  selector: 'app-gestione-deleghe',
  templateUrl: './gestione-deleghe.component.html',
  styleUrls: ['./gestione-deleghe.component.css']
})
export class GestioneDelegheComponent {

}
